import { render, staticRenderFns } from "./crm-add.vue?vue&type=template&id=06a36adf&scoped=true&"
import script from "./crm-add.vue?vue&type=script&lang=js&"
export * from "./crm-add.vue?vue&type=script&lang=js&"
import style0 from "./crm-add.vue?vue&type=style&index=0&id=06a36adf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a36adf",
  null
  
)

export default component.exports